export class DateTimeUtil {
    static MS_SECOND: number = 1000;
    static MS_MINUTE: number = DateTimeUtil.MS_SECOND * 60;
    static MS_HOUR: number = DateTimeUtil.MS_MINUTE * 60;
    static MS_DAY: number = DateTimeUtil.MS_HOUR * 24;
    static MS_WEEK: number = DateTimeUtil.MS_DAY * 7;

    /**
     * Formats seconds into hh:mm:ss
     * @param sec number of seconds
     */
    static formatTimeForSeconds(sec: number) {
        if (!sec) {
            return "";
        }
        const sec_num = parseInt("" + sec, 10);
        const hours = Math.floor(sec_num / 3600);
        const minutes = Math.floor(sec_num / 60) % 60;
        const seconds = Math.floor(sec_num % 60);

        let time = [minutes, seconds]
            .map(v => v < 10 ? "0" + v : v)
            .filter((v, i) => v !== "00" || i > 0)
            .join(":");

        if (hours >= 1) {
            time = hours + "h " + time;
        }

        return time;
    }

    static millisToHours(millis: number): number {
        return Math.floor(millis / DateTimeUtil.MS_HOUR) % 24;
    }

    static millisToMinutes(millis: number): number {
        return Math.floor(millis / DateTimeUtil.MS_MINUTE) % 60;
    }

    static millisToHHMM(millis: number): string {
        return millis == undefined ? undefined : ("00" + DateTimeUtil.millisToHours(millis)).slice(-2) + ":" + ("00" + DateTimeUtil.millisToMinutes(millis)).slice(-2);
    }

    static setDate(to: Date, from: Date): Date {
        if (from && to) {
            to.setFullYear(from.getFullYear(), from.getMonth(), from.getDate());
            return to;
        } else {
            return from;
        }
    }

    static setTime(to: Date, from: Date): Date {
        if (from && to) {
            to.setHours(from.getHours());
            to.setMinutes(from.getMinutes());
            return to;
        } else {
            return from;
        }
    }
}
